// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3gX4k","emails":"CreateEditClinics_emails__2y-6Z","emailTagLabel":"CreateEditClinics_emailTagLabel__NfS5b"};